import {
  REMOVE_MA,
  SET_CANDIDATES,
  SET_CURRENT_MAFID,
  SET_MA_LOADING_STATE,
  SET_MAFID_TO_QUERY,
  SET_PROFILE,
} from './actionTypes';

export const removeMa = () => ({ type: REMOVE_MA });

/**
 * Action creator for storing MedicAlert data for a list of candidates
 * @param {Object} candidates - candidates data received through the Hermes
 * websocket connection
 * @param {?string} [id=null] - ID associated with the phone number the user is
 * viewing in detailed view of JV
 */
export const setCandidates = (candidates, id = null) => ({
  type: SET_CANDIDATES,
  candidates: candidates !== null ? candidates : [],
  id,
});

export const setCurrentMafid = mafid => ({
  type: SET_CURRENT_MAFID,
  mafid,
});

export const setMafidToQuery = mafid => ({
  type: SET_MAFID_TO_QUERY,
  mafid,
});

export const setMaLoadingState = bool => ({
  type: SET_MA_LOADING_STATE,
  bool,
});

/**
 * Action creator for storing MedicAlert data for a profile
 * @param {Object} message - data received through the Hermes websocket
 * connection
 * @param {?string} [id=null] - ID associated with the phone number the user is
 * viewing in detailed view of JV
 */
export const setProfile = (message, id = null) => {
  const mafid = message.topic.split('maf-id://')[1];
  const profile = message.body;
  return {
    type: SET_PROFILE,
    mafid,
    profile,
    id,
  };
};
